const mapDate = (isoDateString) => {
    if (!isoDateString) {
        return isoDateString;
    }
    const utc = isoDateString.endsWith("Z")
        ? isoDateString
        : isoDateString + "Z";
    return utc;
};

export default mapDate;
